import React from 'react';
import { motion } from 'framer-motion';
import QuestionCard from './QuestionCard';
import './PillarSection.css';

const PillarSection = ({
  pillar,
  questions,
  answers,
  errors,
  language,
  onAnswerChange,
  onFocus,
  isBonus = false
}) => {
  const pillarInfo = {
    LEAD: {
      title: { en: 'LEAD', mr: 'नेतृत्व' },
      description: { en: 'Vision, Strategy & Leadership', mr: 'दृष्टी, धोरण आणि नेतृत्व' },
      color: '#667eea'
    },
    EVOLVE: {
      title: { en: 'EVOLVE', mr: 'विकास' },
      description: { en: 'Innovation & Continuous Improvement', mr: 'नवनिर्मिती आणि सतत सुधारणा' },
      color: '#764ba2'
    },
    ALIGN: {
      title: { en: 'ALIGN', mr: 'संरेखन' },
      description: { en: 'Team Alignment & Culture', mr: 'टीम संरेखन आणि संस्कृती' },
      color: '#f093fb'
    },
    PERFORM: {
      title: { en: 'PERFORM', mr: 'कामगिरी' },
      description: { en: 'Execution & Results', mr: 'अंमलबजावणी आणि परिणाम' },
      color: '#4facfe'
    },
    BONUS: {
      title: { en: 'Additional Information', mr: 'अतिरिक्त माहिती' },
      description: { en: 'Help us understand your context better', mr: 'आपला संदर्भ समजून घेण्यास मदत करा' },
      color: '#ffc107'
    }
  };

  const info = pillarInfo[pillar] || pillarInfo.BONUS;

  if (questions.length === 0) {
    return null;
  }

  return (
    <motion.div
      className="pillar-section"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: false, margin: "-100px" }}
      transition={{ duration: 0.6 }}
      onFocus={onFocus}
    >
      <div
        className="pillar-header"
        style={{ borderLeftColor: info.color }}
      >
        <h2 style={{ color: info.color }}>
          {info.title[language] || info.title.en}
        </h2>
        <p>{info.description[language] || info.description.en}</p>
      </div>

      <div className="pillar-questions">
        {questions.map((question, index) => (
          <QuestionCard
            key={question.key}
            question={question}
            answer={answers[question.key]}
            error={errors[question.key]}
            language={language}
            onAnswerChange={onAnswerChange}
            index={index}
            isBonus={isBonus}
          />
        ))}
      </div>
    </motion.div>
  );
};

export default PillarSection;
